import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import AppComponent from './App.jsx';
import { getFirebase } from './services/firebase.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ToastProvider } from './contexts/ToastContext';

// Initialize Firebase early
getFirebase();

// Apply saved theme before first render
(function () {
  const saved = localStorage.getItem('appTheme') || 'system';
  if (saved === 'system') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
  } else {
    document.documentElement.setAttribute('data-theme', saved);
  }
}());

try {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <ToastProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppComponent />
      </Router>
    </ToastProvider>
  );

  // Register the service worker
  serviceWorkerRegistration.register();
} catch (error) {
  console.error('Error starting React app:', error.message, error.stack);
}